
import { computeDebitCredit } from "../../../backend/src/common/accountingLine/accountingLineServices"
import { getConnectAccountableAccount } from "./accountableAccountServices"
import { getDBFormattedDate } from "./dateServices"
import { getVatAAs } from "./vatServices"
import { getDefaultDedVatAAName } from "../../../backend/src/common/vat/vatServices"

export async function formatBncAccountingLines(store, apollo, operation, companyId) {
    const accountingLines = []

    if (operation.grossAmount !== 0) {
        accountingLines.push({
            company: {connect: {id: companyId}},
            wording: operation.title,
            date: getDBFormattedDate(operation.date),
            amount: operation.grossAmount,
            amountSigned: operation.grossAmount * -1,
            accountableAccount: await getConnectAccountableAccount(store, apollo, "108000"),
            useForReconciliation: false
        })
    }

    if (operation.netAmount !== 0) {
        accountingLines.push({
            company: {connect: {id: companyId}},
            wording: operation.title,
            date: getDBFormattedDate(operation.date),
            amount: operation.netAmount,
            amountSigned: operation.netAmount,
            accountableAccount: await getConnectAccountableAccount(store, apollo, operation.type),
            useForReconciliation: false
        })
    }

    const vatAAs = await getVatAAs(store.state.accountableAccountTable)
    const dedVatAAName = getDefaultDedVatAAName(vatAAs)
    if (operation.vatAmount) {
        accountingLines.push({
            company: {connect: {id: companyId}},
            wording: operation.title,
            date: getDBFormattedDate(operation.date),
            amount: operation.vatAmount,
            amountSigned: operation.vatAmount,
            // accountableAccount: await getConnectAccountableAccount(store, apollo, "445660"),
            accountableAccount: await getConnectAccountableAccount(store, apollo, dedVatAAName),
            useForReconciliation: false
        })
    }
    for (const al of accountingLines) {
        computeDebitCredit(al)
    }
    return accountingLines
}

export function getLinkedDocumentId(bt) {
    if (bt) {
        for (const al of bt.accountingLines) {
            if (al.document) {
                return al.document.id
            }

        }
    }
    return null
}
